import React, { useEffect, createElement } from 'react';
export function Modulo0Page() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1388">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1389">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1390">
          AI <span className="text-[#F5C842]" data-id="element-1391">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1392">
          <a href="/modulo-0" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1393">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1394">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1395">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1396">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1397">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1398">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-1399">
        <div className="mb-5 flex flex-wrap items-center gap-2.5" data-id="element-1400">
          <div className="rounded-sm bg-[#4caf50] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1401">
            Empieza Aquí
          </div>
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1402">
            Módulo 0
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1403">
            ⏱ 30 minutos · Configuración del Sistema
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1404">
          Herramientas
          <br data-id="element-1405" />
          <span className="text-[#F5C842]" data-id="element-1406">Necesarias</span> para
          <br data-id="element-1407" />
          tu Sistema
        </div>
        <div className="mb-8 max-w-[640px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1408">
          Antes de conseguir tu primer cliente, necesitas tener las herramientas
          correctas configuradas. En este módulo vas a instalar las 3 piezas
          fundamentales de tu sistema: MagicPatterns, los Custom AI Brains de
          Heylloyd y tu dominio en Namecheap.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1409">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1410">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1411"></div>
            Configuración de MagicPatterns
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1412">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1413"></div>
            Cuenta de Heylloyd + Custom AI Brains
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1414">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1415"></div>2 AI
            Brains listos para descargar
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1416">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1417"></div>
            Dominio en Namecheap
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1418">
        {/* INFO BOX */}
        <div className="mb-6 rounded-r-lg border border-[#1a2a3a] border-l-[4px] border-l-[#4a9eff] bg-[#0a0f1a] px-[22px] py-[18px] text-[13px] leading-[1.75] text-[#aac4e8]" data-id="element-1419">
          <strong className="text-white" data-id="element-1420">¿Por qué este módulo existe?</strong>{' '}
          La mayoría de los cursos te lanzan al contenido sin asegurarse de que
          tienes las herramientas listas. Nosotros hacemos lo contrario.
          Completa este módulo primero y los siguientes van a fluir sin
          fricción.
        </div>

        {/* ==================== VIDEO 1 — MAGICPATTERNS ==================== */}
        <div className="mb-10" data-id="element-1421">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1422">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1423"></span>
            Video 1 de 3
          </div>
          <div className="mb-3.5 inline-flex items-center gap-2 rounded border border-[#2a2a2a] bg-[#1a1a1a] px-3.5 py-1.5" data-id="element-1424">
            <span className="font-heading text-[10px] font-black tracking-[2px] text-[#F5C842] uppercase" data-id="element-1425">
              🛠 Herramienta #1 — MagicPatterns
            </span>
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1426">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1427">
              <iframe src="https://player.vimeo.com/video/1179704772?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 0.0" data-id="element-1428" />
            </div>
          </div>
        </div>

        {/* MAGICPATTERNS CTA BUTTON — right after video */}
        <div className="mt-4 mb-10" data-id="element-1429">
          <a href="https://www.magicpatterns.com/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1430">
            <span className="text-[20px]" data-id="element-1431">🔗</span>
            Abrir MagicPatterns — Crear tu Cuenta
            <span className="text-[18px] font-black" data-id="element-1432">→</span>
          </a>
        </div>

        {/* MAGICPATTERNS INFO */}
        <div className="mb-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1433">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1434">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1435">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1436"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1437">
                ¿Qué es MagicPatterns?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1438">
              MagicPatterns es la herramienta de IA que convierte tus ideas en{' '}
              <strong className="text-white" data-id="element-1439">
                sitios web completos y profesionales
              </strong>{' '}
              en minutos. Sin código, sin diseñadores, sin experiencia técnica.
              <br data-id="element-1440" />
              <br data-id="element-1441" />
              Es el motor que construye los sitios web que vas a vender a tus
              clientes locales.{' '}
              <strong className="text-white" data-id="element-1442">Esta es tu arma principal.</strong>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1443">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1444">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1445"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1446">
                Lo que harás en el video
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1447">
              <ul className="flex flex-col" data-id="element-1448">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1449">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1450">
                    →
                  </span>
                  Crear tu cuenta gratuita en MagicPatterns
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1451">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1452">
                    →
                  </span>
                  Explorar el dashboard y las funciones principales
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1453">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1454">
                    →
                  </span>
                  Generar tu primer sitio web de práctica
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1455">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1456">
                    →
                  </span>
                  Entender cómo personalizar y exportar
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1457">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1458">
                    →
                  </span>
                  Conectar MagicPatterns con tu flujo de trabajo
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* DIVIDER 1-2 */}
        <div className="relative mb-10 border-t border-[#1e1e1e]" data-id="element-1459">
          <div className="absolute left-1/2 top-[-10px] -translate-x-1/2 bg-[#0a0a0a] px-4" data-id="element-1460">
            <span className="text-[9px] font-bold tracking-[3px] text-[#333] uppercase" data-id="element-1461">
              Video 2 de 3
            </span>
          </div>
        </div>

        {/* ==================== VIDEO 2 — HEYLLOYD ==================== */}
        <div className="mb-10" data-id="element-1462">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1463">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1464"></span>
            Video 2 de 3
          </div>
          <div className="mb-3.5 inline-flex items-center gap-2 rounded border border-[#2a2a2a] bg-[#1a1a1a] px-3.5 py-1.5" data-id="element-1465">
            <span className="font-heading text-[10px] font-black tracking-[2px] text-[#F5C842] uppercase" data-id="element-1466">
              🧠 Herramienta #2 — Heylloyd + Custom AI Brains
            </span>
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1467">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1468">
              <iframe src="https://player.vimeo.com/video/1179706172?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 0.3 heylloyd" data-id="element-1469" />
            </div>
          </div>
        </div>

        {/* HEYLLOYD CTA BUTTONS — right after video */}
        <div className="mt-4 mb-10 flex flex-col gap-3" data-id="element-1470">
          <a href="https://heylloyd.io/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1471">
            <span className="text-[20px]" data-id="element-1472">🧠</span>
            Abrir Heylloyd.io — Crear tu Cuenta
            <span className="text-[18px] font-black" data-id="element-1473">→</span>
          </a>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-1474">
            <a href="https://app.heylloyd.io/share/lloyd/d98723a5-a08" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2.5 rounded-lg border-2 border-[#F5C842] bg-[#111] px-5 py-4 font-heading text-[12px] font-black tracking-[1px] text-[#F5C842] uppercase no-underline transition-opacity hover:opacity-85 text-center" data-id="element-1475">
              <span className="text-[16px]" data-id="element-1476">🧠</span>
              <span data-id="element-1477">
                Descargar AI Brain #1
                <br data-id="element-1478" />
                <span className="text-[10px] font-bold text-white" data-id="element-1479">
                  Ai Website Arbitrage
                </span>
              </span>
              <span className="text-[14px]" data-id="element-1480">↓</span>
            </a>
            <a href="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2.5 rounded-lg border-2 border-[#F5C842] bg-[#111] px-5 py-4 font-heading text-[12px] font-black tracking-[1px] text-[#F5C842] uppercase no-underline transition-opacity hover:opacity-85 text-center" data-id="element-1481">
              <span className="text-[16px]" data-id="element-1482">🧠</span>
              <span data-id="element-1483">
                Descargar AI Brain #2
                <br data-id="element-1484" />
                <span className="text-[10px] font-bold text-white" data-id="element-1485">
                  Sales Letter Weapon
                </span>
              </span>
              <span className="text-[14px]" data-id="element-1486">↓</span>
            </a>
          </div>
        </div>

        {/* HEYLLOYD INFO */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1487">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1488">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1489">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1490"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1491">
                ¿Qué es Heylloyd?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1492">
              Heylloyd es la IA que actúa como tu{' '}
              <strong className="text-white" data-id="element-1493">cerebro estratégico</strong>. No es
              un chatbot genérico — está entrenado con estrategias específicas
              para conseguir clientes locales, crear propuestas y cerrar ventas.
              <br data-id="element-1494" />
              <br data-id="element-1495" />
              Los <strong className="text-white" data-id="element-1496">Custom AI Brains</strong> son
              versiones especializadas de Heylloyd, pre-programadas con el
              conocimiento exacto que necesitas para este sistema.
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1497">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1498">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1499"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1500">
                Lo que harás en el video
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1501">
              <ul className="flex flex-col" data-id="element-1502">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1503">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1504">
                    →
                  </span>
                  Crear tu cuenta en Heylloyd
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1505">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1506">
                    →
                  </span>
                  Entender qué son los Custom AI Brains
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1507">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1508">
                    →
                  </span>
                  Descargar e instalar los 2 AI Brains del sistema
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1509">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1510">
                    →
                  </span>
                  Hacer tu primera prueba con cada Brain
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1511">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1512">
                    →
                  </span>
                  Integrar Heylloyd en tu flujo de trabajo diario
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* DIVIDER 2-3 */}
        <div className="relative mb-10 border-t border-[#1e1e1e]" data-id="element-1513">
          <div className="absolute left-1/2 top-[-10px] -translate-x-1/2 bg-[#0a0a0a] px-4" data-id="element-1514">
            <span className="text-[9px] font-bold tracking-[3px] text-[#333] uppercase" data-id="element-1515">
              Video 3 de 3
            </span>
          </div>
        </div>

        {/* ==================== VIDEO 3 — NAMECHEAP ==================== */}
        <div className="mb-10" data-id="element-1516">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1517">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1518"></span>
            Video 3 de 3
          </div>
          <div className="mb-3.5 inline-flex items-center gap-2 rounded border border-[#2a2a2a] bg-[#1a1a1a] px-3.5 py-1.5" data-id="element-1519">
            <span className="font-heading text-[10px] font-black tracking-[2px] text-[#F5C842] uppercase" data-id="element-1520">
              🌐 Herramienta #3 — Namecheap
            </span>
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1521">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1522">
              <iframe src="https://player.vimeo.com/video/1179701343?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 0.1" data-id="element-1523" />
            </div>
          </div>
        </div>

        {/* NAMECHEAP CTA BUTTON — right after video */}
        <div className="mt-4 mb-10" data-id="element-1524">
          <a href="https://www.namecheap.com/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1525">
            <span className="text-[20px]" data-id="element-1526">🌐</span>
            Abrir Namecheap — Registrar tu Dominio
            <span className="text-[18px] font-black" data-id="element-1527">→</span>
          </a>
        </div>

        {/* NAMECHEAP INFO */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1528">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1529">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1530">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1531"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1532">
                ¿Qué es Namecheap?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1533">
              Namecheap es el registrador de dominios donde vas a comprar el
              dominio de tus clientes. Un dominio profesional le da{' '}
              <strong className="text-white" data-id="element-1534">credibilidad inmediata</strong> al
              sitio web que entregas y justifica tu precio de $350.
              <br data-id="element-1535" />
              <br data-id="element-1536" />
              Es rápido, económico y fácil de usar.{' '}
              <strong className="text-white" data-id="element-1537">
                Un dominio cuesta menos de $15 al año.
              </strong>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1538">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1539">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1540"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1541">
                Lo que harás en el video
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1542">
              <ul className="flex flex-col" data-id="element-1543">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1544">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1545">
                    →
                  </span>
                  Crear tu cuenta en Namecheap
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1546">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1547">
                    →
                  </span>
                  Buscar y registrar un dominio para tu cliente
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1548">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1549">
                    →
                  </span>
                  Entender cómo funciona el DNS y el hosting
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1550">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1551">
                    →
                  </span>
                  Conectar el dominio con el sitio web del cliente
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1552">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1553">
                    →
                  </span>
                  Gestionar múltiples dominios desde un solo panel
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* AI BRAINS DOWNLOAD SECTION */}
        <div className="mb-10 overflow-hidden rounded-[10px] border border-[#1e1e1e] bg-[#0d0d0d]" data-id="element-1554">
          <div className="flex items-center gap-3.5 border-b-[2px] border-[#F5C842] bg-gradient-to-r from-[#1a1400] to-[#0d0d0d] px-7 py-5" data-id="element-1555">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-[#F5C842] text-[20px]" data-id="element-1556">
              🧠
            </div>
            <div data-id="element-1557">
              <h3 className="mb-1 font-heading text-[16px] font-black text-white" data-id="element-1558">
                Descarga tus Custom AI Brains
              </h3>
              <p className="text-[12px] text-[#888]" data-id="element-1559">
                Los 2 cerebros de IA pre-entrenados para tu sistema AI Web
                Closer
              </p>
            </div>
          </div>
          <div className="px-7 py-6" data-id="element-1560">
            <div className="mb-6 text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1561">
              Estos no son prompts genéricos. Son{' '}
              <strong className="text-[#F5C842]" data-id="element-1562">Custom AI Brains</strong> —
              versiones especializadas de Heylloyd entrenadas específicamente
              para las dos tareas más críticas de tu negocio. Descárgalos
              después de ver el video y tenlos listos antes de pasar al Módulo
              1.
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-1563">
              {/* BRAIN 1 */}
              <div className="flex flex-col gap-3.5 rounded-lg border border-[#2a2a2a] bg-[#111] p-5 transition-colors hover:border-[#F5C842]" data-id="element-1564">
                <div className="flex items-start gap-3" data-id="element-1565">
                  <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1566">
                    01
                  </div>
                  <div data-id="element-1567">
                    <h4 className="mb-1 font-heading text-[13px] font-black text-white" data-id="element-1568">
                      Ai Website Arbitrage
                    </h4>
                    <p className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1569">
                      El cerebro especializado en identificar oportunidades de
                      mercado, analizar negocios locales sin sitio web y generar
                      estrategias de prospección. Tu arma para encontrar
                      clientes.
                    </p>
                  </div>
                </div>
                <a href="https://app.heylloyd.io/share/lloyd/d98723a5-a08" target="_blank" rel="noreferrer" className="mt-auto flex items-center justify-center gap-2 rounded-md bg-[#F5C842] px-4 py-2.5 font-heading text-[11px] font-black tracking-[1px] text-black uppercase no-underline transition-opacity hover:opacity-85" data-id="element-1570">
                  <span className="text-[14px]" data-id="element-1571">⬇</span>
                  Descargar AI Brain #1 — Website Arbitrage
                </a>
              </div>

              {/* BRAIN 2 */}
              <div className="flex flex-col gap-3.5 rounded-lg border border-[#2a2a2a] bg-[#111] p-5 transition-colors hover:border-[#F5C842]" data-id="element-1572">
                <div className="flex items-start gap-3" data-id="element-1573">
                  <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1574">
                    02
                  </div>
                  <div data-id="element-1575">
                    <h4 className="mb-1 font-heading text-[13px] font-black text-white" data-id="element-1576">
                      Sales Letter Weapon
                    </h4>
                    <p className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1577">
                      El cerebro especializado en crear propuestas
                      irresistibles, sales pages de alta conversión y mensajes
                      de cierre. Tu arma para convertir prospectos en clientes
                      que pagan.
                    </p>
                  </div>
                </div>
                <a href="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" target="_blank" rel="noreferrer" className="mt-auto flex items-center justify-center gap-2 rounded-md bg-[#F5C842] px-4 py-2.5 font-heading text-[11px] font-black tracking-[1px] text-black uppercase no-underline transition-opacity hover:opacity-85" data-id="element-1578">
                  <span className="text-[14px]" data-id="element-1579">⬇</span>
                  Descargar AI Brain #2 — Sales Letter Weapon
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* TASK BOX */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1580">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1581">
            ✅ Tarea de Acción — Módulo 0
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1582">
            <strong className="text-white" data-id="element-1583">
              Antes de pasar al Módulo 1, completa estos 5 pasos:
            </strong>
            <div className="mt-3 flex flex-col gap-2" data-id="element-1584">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1585">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1586">
                  1
                </div>
                <div data-id="element-1587">
                  Ve el Video 1 y crea tu cuenta en{' '}
                  <strong className="text-white" data-id="element-1588">MagicPatterns</strong>. Genera
                  un sitio web de prueba con cualquier prompt para
                  familiarizarte con la herramienta.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1589">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1590">
                  2
                </div>
                <div data-id="element-1591">
                  Ve el Video 2 y crea tu cuenta en{' '}
                  <strong className="text-white" data-id="element-1592">Heylloyd</strong>.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1593">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1594">
                  3
                </div>
                <div data-id="element-1595">
                  Descarga e instala los{' '}
                  <strong className="text-white" data-id="element-1596">2 Custom AI Brains</strong>{' '}
                  usando los botones de arriba. Ábrelos en Heylloyd y haz una
                  pregunta de prueba a cada uno.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1597">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1598">
                  4
                </div>
                <div data-id="element-1599">
                  Ve el Video 3 y crea tu cuenta en{' '}
                  <strong className="text-white" data-id="element-1600">Namecheap</strong>.
                  Familiarízate con el panel de dominios — lo vas a usar desde
                  el Módulo 1.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1601">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1602">
                  5
                </div>
                <div data-id="element-1603">
                  Cuando tengas las 3 herramientas activas y los 2 AI Brains
                  instalados,{' '}
                  <strong className="text-white" data-id="element-1604">pasa al Módulo 1</strong>.
                  Estás listo.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1605">
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1606">
          AI <span className="text-[#F5C842]" data-id="element-1607">WEB CLOSER</span>
        </div>
        <a href="/modulo-1" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-1608">
          Módulo 1 — El Mercado de Oro →
        </a>
      </div>
    </div>;
}